import '../sass/frontend.scss';
jQuery(function() {
    class FreeShippingChecker {
        constructor() {
            this.freeShippingBar = jQuery('#free-shipping-you-will-get-bar');
            this.init();
        }

        init() {
            this.observeDOMChanges();
        }

        checkFreeShipping() {
            const freeShippingThreshold = parseFloat(this.freeShippingBar.data('free-shipping-threshold'));
            const productPriceSelector = this.freeShippingBar.data('product-price-selector');
            const totalPriceWithDiscount = jQuery(productPriceSelector);
            if (totalPriceWithDiscount.length === 0) {
                return;
            }

            let decimalSeparator = this.freeShippingBar.data('product-decimal-separator').toString();
            const productPrice = parseFloat(totalPriceWithDiscount.text().replace(decimalSeparator, '.'));

            let cartSubtotal = parseFloat(this.freeShippingBar.data('cart-subtotal'));

            const $floatingCartSubtotalElement = jQuery('#swoo-floating-ajax-cart-popup-pro-subtotal');
            if ($floatingCartSubtotalElement.length) {
                cartSubtotal = parseFloat($floatingCartSubtotalElement.data('subtotal'));
            }

            // Convert to two decimal points
            cartSubtotal = Math.round(cartSubtotal * 100) / 100

            let amountTotal = productPrice + cartSubtotal;

            if (amountTotal >= freeShippingThreshold) {
                this.freeShippingBar.show();
            } else {
                this.freeShippingBar.hide();
            }
        }

        debounce(func, wait) {
            let timeout;
            return () => {
                clearTimeout(timeout);
                timeout = setTimeout(func, wait);
            };
        }

        observeDOMChanges() {
            const targetNode = jQuery('body')[0];
            const config = { childList: true, subtree: true, attributes: true, characterData: true };

            const debouncedCheckFreeShipping = this.debounce(() => this.checkFreeShipping(), 100);

            const callback = () => {
                debouncedCheckFreeShipping();
            };

            const observer = new MutationObserver(callback);
            observer.observe(targetNode, config);
        }
    }

    new FreeShippingChecker();

    if (!jQuery('.free-shipping-reminder-wrapper.is-ajax-mode').length) {
        return;
    }
    jQuery(document.body).on('updated_wc_div', function() {
        jQuery.ajax({
            url: ajax_params.ajax_url,
            type: 'POST',
            data: {
                action: 'swoo_cart_free_shipping_bar',
                nonce: ajax_params.nonce
            },
            success: function(response) {
                jQuery('.free-shipping-reminder-wrapper').html(response); // Update the HTML with the response
            },
            error: function() {
                window.console.warn('Could not update the free shipping bar');
            }
        });
    });
});
